import {
  APPLICANT_PROFILE_BLOCK,
  APPLICANT_PROFILE_BLOCK_PARAM,
} from '../../../../../../RentalPortalApplicant'

export function getIsApplicantDecisionAnchorRequested(searchParams) {
  return (
    searchParams.get(APPLICANT_PROFILE_BLOCK_PARAM) ===
    APPLICANT_PROFILE_BLOCK.decision
  )
}
